"use client";

import LoginRedirectionModal from "@/components/features/auth/LoginRedirectionModal";
import { AdminRole } from "@/types/auth/LoginUserTypes";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";

export default function PortalAuthRedirect() {
  const { data: session, status } = useSession();
  const [adminRole, setAdminRole] = useState<AdminRole | null>(null);
  const [showRedirectionModal, setShowRedirectionModal] = useState(false);

  useEffect(() => {
    if (status !== "authenticated") return;
    if (!session?.portalData?.nonce) return;

    setAdminRole(session.portalData);
    setShowRedirectionModal(true);
  }, [status, session?.portalData]);

  if (!adminRole) return null;

  return (
    <LoginRedirectionModal
      setShowRedirectionModal={setShowRedirectionModal}
      showRedirectionModal={showRedirectionModal}
      adminRole={adminRole}
    />
  );
}
